var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useOutSideClick, useTheme, useToast } from "../../../hooks";
import { debounce, isEmpty } from 'lodash';
import React, { useCallback, useEffect, useRef, useState, } from 'react';
import { css, styled } from "../../../utils";
import PlaceSearchAPI from "./api";
import AutoCompletions, { AutoCompletionsItem } from "../AutoCompletions";
import Input, { InputProps } from "../Input";
var ENTER_KEY = 13;
var TAB_KEY = 9;
var Container = styled.div(function (_a) {
    var containerStyle = _a.containerStyle;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    ", "\n  "], ["\n    position: relative;\n    ", "\n  "])), containerStyle);
});
var PlaceSearch = function (_a) {
    var _b;
    var onChange = _a.onChange, onFocus = _a.onFocus, _c = _a.validation, validation = _c === void 0 ? true : _c, containerStyle = _a.containerStyle, _d = _a.value, value = _d === void 0 ? {} : _d, _e = _a.apiErrorMessage, apiErrorMessage = _e === void 0 ? 'Cannot fetch place data' : _e, props = __rest(_a, ["onChange", "onFocus", "validation", "containerStyle", "value", "apiErrorMessage"]);
    var config = useTheme().config;
    var api = PlaceSearchAPI.getInstance(config);
    var inputRef = useRef(null);
    var addToast = useToast().addToast;
    var _f = useState(false), loading = _f[0], setLoading = _f[1];
    var _g = useState(api.getInputValue(value)), inputValue = _g[0], setInputValue = _g[1];
    var _h = useState([]), autoCompletions = _h[0], setAutoCompletions = _h[1];
    var setPlaceState = function (place) {
        setAutoCompletions([]);
        setInputValue(api.getInputValue(place));
        if (onChange) {
            onChange(place);
        }
    };
    useEffect(function () {
        if (value.city && (!value.lat || !value.lon || !value.code || !value.country)) {
            setLoading(true);
            api
                .fetchAutoCompletions(value.city)
                .then(function (_a) {
                var _b = _a[0], name = _b[0], id = _b[1];
                return api.fetchPlaceDetails(id, name);
            })
                .then(function (place) { return setPlaceState(place); })
                .then(function () { return setLoading(false); })
                .catch(function () {
                setPlaceState({});
                setLoading(false);
            });
        }
    }, [value.city, value.lat, value.lon, value.code, value.country]);
    var getAutoCompletions = useCallback(debounce(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var autoCompletions_1, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(value.length >= 3 && value.length < 40)) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4, api.fetchAutoCompletions(value)];
                case 2:
                    autoCompletions_1 = _a.sent();
                    setLoading(false);
                    setAutoCompletions(autoCompletions_1);
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    setLoading(false);
                    addToast(apiErrorMessage, 'error');
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); }, 250), []);
    var handleInputChange = function (_a) {
        var value = _a.target.value;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setInputValue(value);
                        return [4, getAutoCompletions(value)];
                    case 1:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    var handleItemClick = function (placeId, placeName) { return __awaiter(void 0, void 0, void 0, function () {
        var place, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4, api.fetchPlaceDetails(placeId, placeName)];
                case 1:
                    place = _a.sent();
                    setLoading(false);
                    setPlaceState(place);
                    return [3, 3];
                case 2:
                    err_2 = _a.sent();
                    setLoading(false);
                    addToast(apiErrorMessage, 'error');
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var handleFocus = function (e) {
        if (onFocus) {
            onFocus(e);
        }
        setPlaceState({});
    };
    var handleOutSideClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, city, placeId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!isEmpty(autoCompletions)) return [3, 2];
                    _a = autoCompletions[0], city = _a[0], placeId = _a[1];
                    return [4, handleItemClick(placeId, city)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2];
            }
        });
    }); };
    var handleKeyDown = function (event) {
        if (event.keyCode === ENTER_KEY || event.keyCode === TAB_KEY) {
            event.preventDefault();
            handleOutSideClick();
        }
    };
    var parentRef = useOutSideClick(handleOutSideClick);
    return (React.createElement(Container, { "data-component": "PlaceSearch", containerStyle: containerStyle, ref: parentRef },
        React.createElement(Input, __assign({}, props, { value: inputValue, autoComplete: "off", ref: inputRef, onKeyDown: handleKeyDown, onChange: handleInputChange, onFocus: handleFocus, validation: false, loading: loading, loadingDelay: 500 })),
        React.createElement(AutoCompletions, { isOpen: inputValue && !isEmpty(autoCompletions), offset: (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight, renderItem: autoCompletions.map(function (_a) {
                var name = _a[0], id = _a[1], description = _a[2];
                return (React.createElement(AutoCompletionsItem, { key: id, value: description || name, highlight: inputValue, onClick: function () { return handleItemClick(id, name); } }));
            }) })));
};
export default PlaceSearch;
var templateObject_1;
//# sourceMappingURL=PlaceSearch.js.map